export default __webpack_public_path__ + "static/media/DOGE-BNB.1f2edf56.svg";